/**
 * How a real `Team` reads as a flat row — same reasoning `campaignShape.js`
 * gives for campaigns.
 */

/** `core.record_status` — copied, not re-derived, same as every other module's constants. */
export const TEAM_STATUS = ['active', 'inactive', 'archived'];

export const STATUS_LABEL = { active: 'Active', inactive: 'Inactive', archived: 'Archived' };
export const STATUS_TONE = { active: 'emerald', inactive: 'amber', archived: 'neutral' };

export function toRow(t) {
  return {
    id: t.id,
    code: t.code,
    name: t.name,
    businessUnit: t.business_unit?.name ?? null,
    parent: t.parent ?? null,
    path: t.path,
    manager: t.manager,
    memberCount: t.member_count,
    status: t.status,
    statusLabel: STATUS_LABEL[t.status] ?? t.status,
    statusTone: STATUS_TONE[t.status] ?? 'neutral',
    createdAt: t.created_at,
    rowVersion: t.row_version,
    raw: t,
  };
}

export function toMemberRow(m) {
  return {
    id: m.user.id,
    fullName: m.user.full_name,
    email: m.user.email,
    isLead: m.is_lead,
    joinedOn: m.joined_on,
    leftOn: m.left_on,
  };
}
